import { SectionGridSize, SectionMinHeights } from "../helpers/enums";

export const nineColumnsGrid = {
  gridTemplateColumns: "2% 2% 2% 2% 1fr 2% 2% 2% 2%",
  "@media screen and (min-width: 650px)": {
    gridTemplateColumns: "1fr 1fr 1fr 1fr 600px 1fr 1fr 1fr 1fr",
  },
  "@media screen and (min-width: 800px)": {
    gridTemplateColumns: "1fr 1fr 1fr 1fr 700px 1fr 1fr 1fr 1fr",
  },
};

export const twelveColumnsGrid = {
  gridTemplateColumns:
    "minmax(12px, 1fr) repeat(10, minmax(0, 1fr)) minmax(12px, 1fr)",
  "@media screen and (min-width: 1024px)": {
    gridTemplateColumns: "repeat(12, 1fr)",
  },
};

export const thumbnailGrid = {
  minHeight: "initial !important",
  height: "350px",
  width: "700px",
  gridTemplateColumns: ({ gridSize }) =>
    gridSize === SectionGridSize.TWELVE_COLUMNS
      ? "repeat(12, 1fr)"
      : "2% 2% 2% 2% 1fr 2% 2% 2% 2%",
};

export const calculateMinHeight = ({ minHeight, contentHeight = 0 }) => {
  switch (minHeight) {
    case SectionMinHeights.ONE_AND_HALF:
    case "150vh":
    case 1.5:
      return contentHeight * 1.5;
    case SectionMinHeights.TWO:
    case "200vh":
    case 2:
      return contentHeight * 2;
    case SectionMinHeights.THREE:
    case "300vh":
    case 3:
      return contentHeight * 3;
    case SectionMinHeights.HALF:
    case "50vh":
    case 0.5:
      return contentHeight / 2;
    case SectionMinHeights.QUARTER:
    case "25vh":
    case 0.25:
      return contentHeight / 4;
    case SectionMinHeights.CONTENT:
    case "100px":
      return 100;
    case SectionMinHeights.ONE:
    case SectionMinHeights.FULL:
    case "100vh":
    case 1:
      return contentHeight;
    default:
      return contentHeight;
  }
};
